<template>
  <div class="row-content" style="padding: 1.25rem;font-size:12px ;" >
    <div class="row-title">精英机构数量</div>
    <div class="data-wrapper">
      <div class="data-item">
        <div class="data">19</div>
        <div class="data-title">总数量</div>
      </div>
      <div class="data-item">
        <div class="data">10</div>
        <div class="data-title">精英培训机构（A类)</div>
      </div>
      <div class="data-item">
        <div class="data">9</div>
        <div class="data-title">精英培训机构（B类）</div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    props: {
      numStatistical: {
        type: Object,
        required: true,
        default: {
          a: 0,
          B: 0,
          C: 0,
          D: 0,
        },
      },
    },
    computed: {
      year() {
        const year = new Date().getFullYear();
        return year;
      },

      allNumber() {
        let allCounts = 0;
        for (let key in this.numStatistical) {
          allCounts += this.numStatistical[key]
        }
        return allCounts
      },
    },
    data() {
      return {
        loading: false,
      };
    },

    methods: {

    },
  };
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable1'

  .row-content
    position absolute
    top -4rem
    right -1.5rem
    bottom -0.875rem
    left -5.5rem
    padding 1.25rem 2rem
  .row-title
    color #68d8fe
    font-weight 600
    font-size 16px
    margin-bottom 0.4rem
    display flex
    align-items center
  .data-wrapper
    display flex
    flex-wrap wrap
    .data-item
      flex 1
      font-size 12px
      text-align center
      .data
        font-size 26px
      .data-title
        color #4c9bfd
        margin-top 5px
</style>
